import { render, staticRenderFns } from "./SuppliersEdit.vue?vue&type=template&id=a29774a2&"
import script from "./SuppliersEdit.vue?vue&type=script&lang=js&"
export * from "./SuppliersEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports